import { Component, EventEmitter, Input, Output, inject } from '@angular/core';
import { ThemeService } from '../services/theme';
import { themeAsset } from '../services/theme-asset';
import { V3InfoButton } from '../v3-info-button/v3-info-button';

@Component({
  selector: 'app-v3-powered-by-header',
  templateUrl: './v3-powered-by-header.html',
  styleUrl: './v3-powered-by-header.scss',
  standalone: true,
  imports: [V3InfoButton],
})
export class V3PoweredByHeader {
  // Zero desktop variant: the exit-to-parent close button replaces the general info modal's icon
  // — see v3-root/CLAUDE.md.
  @Input() desktop = false;
  @Output() closeClicked = new EventEmitter<void>();

  private readonly themeService = inject(ThemeService);

  readonly logoSrc = themeAsset(this.themeService, 'finanzen');
  readonly closeIconSrc = themeAsset(this.themeService, 'closePlain');
}
